import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css";

const contactDetails = [
  {
    icon: "bi bi-geo-alt",
    title: "Address",
    content: "ABCD International Family 304, Juhu, Mumbai 400052",
    delay: 200,
  },
  {
    icon: "bi bi-telephone",
    title: "Call Us",
    content: "+919324553209, +919322503465",
    delay: 300,
  },
  {
    icon: "bi bi-envelope",
    title: "Email Us",
    content: "abcdinternationalfamily@gmail.com",
    delay: 400,
  },
];

const formFields = [
  { name: "name", type: "text", placeholder: "Your Name", required: true },
  { name: "email", type: "email", placeholder: "Your Email", required: true },
  { name: "subject", type: "text", placeholder: "Subject", required: true },
  { name: "message", type: "textarea", placeholder: "Message", rows: 4, required: true },
];

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const initialForm = formFields.reduce((acc, field) => {
    acc[field.name] = "";
    return acc;
  }, {});

  const [formData, setFormData] = useState(initialForm);
  const [status, setStatus] = useState({ loading: false, success: "", error: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: "", error: "" });

    setTimeout(() => {
      setStatus({
        loading: false,
        success: "Your message has been sent. Thank you!",
        error: "",
      });
      setFormData(initialForm);
    }, 1500);
  };

  return (
    <section id="contact" className="contact section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>Need assistance? Contact our team and we’ll get back to you shortly.</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4 mt-4">
          {/* Contact Info */}
          <div className="col-lg-6">
            <div className="row gy-4">
              {contactDetails.map((detail, idx) => (
                <div
                  className={`col-md-${detail.title === "Address" ? "12" : "6"}`}
                  key={idx}
                >
                  <div
                    className="info-item d-flex flex-column justify-content-center align-items-center"
                    data-aos="fade-up"
                    data-aos-delay={detail.delay}
                  >
                    <i className={detail.icon}></i>
                    <h3>{detail.title}</h3>
                    <p>{detail.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-6">
            <form
              onSubmit={handleSubmit}
              className="php-email-form"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="row gy-4">
                {formFields.map((field, idx) => (
                  <div
                    className={`col-md-${
                      field.name === "subject" || field.name === "message" ? "12" : "6"
                    }`}
                    key={idx}
                  >
                    {field.type === "textarea" ? (
                      <textarea
                        name={field.name}
                        className="form-control"
                        rows={field.rows}
                        placeholder={field.placeholder}
                        value={formData[field.name]}
                        onChange={handleChange}
                        required={field.required}
                      />
                    ) : (
                      <input
                        type={field.type}
                        name={field.name}
                        className="form-control"
                        placeholder={field.placeholder}
                        value={formData[field.name]}
                        onChange={handleChange}
                        required={field.required}
                      />
                    )}
                  </div>
                ))}

                <div className="col-md-12 text-center">
                  {status.loading && <div className="loading">Loading</div>}
                  {status.error && <div className="error-message">{status.error}</div>}
                  {status.success && <div className="sent-message">{status.success}</div>}

                  <button type="submit" disabled={status.loading}>
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Full-width Map Section */}
      <div className="container-fluid mt-5" data-aos="fade-up" data-aos-delay="600">
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.839280508602!2d72.826!3d19.102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9d8f3d7bdf5%3A0x1a82a4d45e5c7a44!2sJuhu%20Beach!5e0!3m2!1sen!2sin!4v1693759176000!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
